import { cn } from "@/lib/utils"

function Skeleton({
  className,
  ...props
}) {
  return (
    <div
      data-slot="skeleton"
      className={cn("rounded-md bg-muted/70", className)}
      {...props} />
  );
}

export { Skeleton }
